module.exports = __webpack_public_path__ + "/00f50bcb4828bb397b220b8ba205f941.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/info/signature_modal@2x.png
 ** module id = 1226
 ** module chunks = 0
 **/